/* oxlint-disable */
/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.config file > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/

import { createSSRApp, createApp } from 'vue'





// We load Quasar stylesheet file
import 'quasar/dist/quasar.sass'


import '@/css/app.scss'
import '@fortawesome/fontawesome-pro/css/fontawesome.css'
import '@fortawesome/fontawesome-pro/css/light.css'
import '@fortawesome/fontawesome-pro/css/brands.css'
import '@fortawesome/fontawesome-pro/css/regular.css'
import '@fortawesome/fontawesome-pro/css/solid.css'
import '@fortawesome/fontawesome-pro/css/duotone.css'

import createQuasarApp, { isClientSideRenderedPage } from './app.js'
import quasarUserOptions from './quasar-user-options.js'


import { addPreFetchHooks } from './client-prefetch.js'


const publicPath = `/`

async function start ({
  app,
  router
  , store}, bootFiles) {
    let hasRedirected = false
  const getRedirectUrl = url => {
    try { return router.resolve(url).href }
    catch (err) {}

    return Object(url) === url
      ? null
      : url
  }
  const redirect = url => {
    hasRedirected = true

    if (typeof url === 'string' && /^https?:\/\//.test(url)) {
      window.location.href = url
      return
    }

    const href = getRedirectUrl(url)

    // continue if we didn't fail to resolve the url
    if (href !== null) {
      window.location.href = href
          }
  }

  // the router-facing URL: no publicPath, no hash-mode "#"
  const urlPath = window.location.href.replace(window.location.origin, '')
  for (let i = 0; hasRedirected === false && i < bootFiles.length; i++) {
    try {
      await bootFiles[i]({
        app,
        router,
        store,        ssrContext: null,
        redirect,
        urlPath,
        publicPath
      })
    }
    catch (err) {
      if (!hasRedirected) console.error('[Quasar] boot error:', err)
      return
    }
  }

  if (hasRedirected) return
  
  app.use(router)

    if (isClientSideRenderedPage) {
            addPreFetchHooks({ router, isClientSideRenderedPage, store, publicPath })
            app.mount('#q-app')
    }
    else {
      // wait until router has resolved all async before hooks
      // and async components...
      router.isReady().then(() => {
                addPreFetchHooks({ router, store, publicPath })
                app.mount('#q-app')

              })
    }

}

createQuasarApp(isClientSideRenderedPage ? createApp : createSSRApp, quasarUserOptions)
  .then(app => {
    // eventually remove this when Cordova/Capacitor/Electron support becomes old
    const [ method, mapFn ] = Promise.allSettled !== void 0
      ? [
        'allSettled',
        bootFiles => bootFiles.map(result => {
          if (result.status === 'rejected') {
            console.error('[Quasar] boot error:', result.reason)
            return
          }
          return result.value.default
        })
      ]
      : [
        'all',
        bootFiles => bootFiles.map(entry => entry.default)
      ]

    return Promise[ method ]([
            import('@/boot/axios'),            import('@/boot/VueGoogleMaps'),            import('@/boot/notify-defaults'),            import('@/boot/global-components'),            import('@/boot/filters'),            import('@/boot/eventBus'),            import('@/boot/sentry-config'),            import('@/boot/visual-viewport'),            import('@/boot/router-global')          ]).then(bootFiles => {
      const boot = mapFn(bootFiles).filter(entry => typeof entry === 'function')
      start(app, boot)
    })
  })
